export default {
  title: 'Marketing Leads',
  search: {
    companyName: 'Company Name',
    companyNamePlaceholder: 'Enter company name',
    contactPerson: 'Contact Person',
    contactPersonPlaceholder: 'Enter contact person',
    source: 'Source',
    sourcePlaceholder: 'Select source',
    status: 'Status',
    statusPlaceholder: 'Select status',
    searchBtn: 'Search',
    resetBtn: 'Reset'
  },
  table: {
    columns: {
      companyName: 'Company Name',
      contactPerson: 'Contact Person',
      phone: 'Phone',
      email: 'Email',
      source: 'Source',
      status: 'Status',
      dateCreated: 'Submitted At',
      latestFollowTime: 'Latest Follow-Up Time',
      followBy: 'Followed By',
      actions: 'Actions'
    },
    actions: {
      view: 'View',
      followUp: 'Follow Up',
      delete: 'Delete'
    }
  },
  dialogs: {
    viewTitle: 'Lead Details',
    followUpTitle: 'Follow Up Lead',
    deleteTitle: 'Confirm Delete',
    deleteContent: 'Are you sure you want to delete this lead?',
    deleteRestoreWarn: 'This action cannot be undone. Are you sure you want to delete?',
    followRecord: 'Follow-Up Notes',
    followRecordPlaceholder: 'Please describe this follow-up in detail...',
    followRecordRequired: 'Please fill in the follow-up notes'
  },
  messages: {
    fetchFailed: 'Failed to fetch data, please try again',
    searchSuccess: 'Search completed',
    searchFailed: 'Search failed, please try again',
    resetInfo: 'Search conditions have been reset',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed, please try again',
    followSuccess: 'Followed up lead: {name}',
    followFailed: 'Follow-up failed, please try again',
    deleteSuccess: 'Deleted lead: {name}',
    deleteFailed: 'Delete failed, please try again'
  },
  sources: {
    home: 'Homepage',
    ai: 'AI Import'
  },
  status: {
    pending: 'Pending',
    followed: 'Followed Up'
  }
}
